export default () => ({
  loadingRooms: false,
  rooms: [],
  selectedRooms: []
})
